import { Component, OnInit, OnChanges } from '@angular/core';
import { CategoryService } from '../../../services/category.service';
import { UserService } from '../../../services/user.service';
import { TareasService } from '../../../services/tareas.service';
import { AddUsersProyect } from 'src/app/models/category/category.module';
declare var $: any;
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-usuarios',
  templateUrl: './add-usuarios.component.html',
  styleUrls: ['./add-usuarios.component.css']
})
export class AddUsuariosComponent implements OnInit {
  //@Input() info: any;
  status = "cargando";
  cat;
  token;
  agregar_usuario: any;
  info: AddUsersProyect;
  del_info: AddUsersProyect;

  constructor(private _categoryService: CategoryService, private _userService: UserService, private _tareasService: TareasService) {

    this.cat = _categoryService.category;
    const token = this._userService.getToken();
    this.token = token;
    const user = this._userService.getIdentity();
    this.info = new AddUsersProyect(user.sub, [], this.cat.id);
    this.carga_usuarios();
  }
  ngOnInit(): void {
    $('select').selectpicker();
    setTimeout(() => {
      $('select').selectpicker('refresh');
    }, 1000);
  }

  carga_usuarios() {
    this._tareasService.getUsersCat(this.cat, this.token).subscribe(
      response => {
        this.agregar_usuario = response;
      },
      error => {
        console.log(error);
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    );
  }

  eliminaruserclient(id) {
    this.del_info = new AddUsersProyect(id, [], 0);
    Swal.fire({
      title: '¿Eliminar Usuario?',
      text: "Desea eliminar al usuario del proyecto",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this._tareasService.delUsersProyect(this.del_info, this.token).subscribe(
          response => {
            this.carga_usuarios();
            setTimeout(() => {
              $('select').selectpicker('refresh');
            }, 1000);
          },
          error => {
            console.log(error);
          }
        );
      }
    });
  }
  eliminaruserproyect(id) {
    this.del_info = new AddUsersProyect(id, [], 0);
    this.del_info = new AddUsersProyect(id, [], 0);
    Swal.fire({
      title: '¿Eliminar Usuario?',
      text: "Desea eliminar al usuario del proyecto",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {
        this._tareasService.delUsersProyect(this.del_info, this.token).subscribe(
          response => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Se elimino al usuario correctamente',
              showConfirmButton: false,
              timer: 1500
            });
            this.carga_usuarios();
            setTimeout(() => {
              $('select').selectpicker('refresh');
            }, 1500);
          },
          error => {
            console.log(error);
          }
        );
      }
    });

  }
  actualizar_list_users() {
    $('select').selectpicker('refresh');
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Se actualizo la lista de usuarios',
      showConfirmButton: false,
      timer: 1500
    });
  }
  onSubmit(form) {
    //console.log(this.info);
    this._tareasService.addUsersProyect(this.info, this.token).subscribe(
      response => {
        //console.log(response);

        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se actualizó la lista de usuario correctamente',
          showConfirmButton: false,
          timer: 1500
        });
        this.carga_usuarios();
        setTimeout(() => {
          $('select').selectpicker('refresh');
        }, 1500);
      },
      error => {
        console.log(error);
      }
    );
  }
}
